import React from 'react';
import DOMPurify from 'dompurify';
import './PropertyFeature.css';

const sanitizeSvg = (svg) => {
  return DOMPurify.sanitize(svg, {
    USE_PROFILES: { svg: true, svgFilters: true },
    ALLOWED_TAGS: ['svg', 'path', 'g', 'circle', 'rect', 'line', 'polyline', 'polygon', 'ellipse', 'defs', 'clipPath', 'use'],
    ALLOWED_ATTR: ['viewBox', 'd', 'fill', 'stroke', 'stroke-width', 'class', 'cx', 'cy', 'r', 'x', 'y', 'width', 'height', 'transform', 'id', 'clip-path']
  });
};

function PropertyFeature({ icon, iconSvg, label }) {
  return (
    <div className="additional-feature">
      {iconSvg ? (
        <span
          className="additional-feature-icon additional-feature-icon-svg"
          dangerouslySetInnerHTML={{ __html: sanitizeSvg(iconSvg) }}
        />
      ) : (
        <img src={icon} alt={label} className="additional-feature-icon" />
      )}
      <span className="additional-feature-text">{label}</span>
    </div>
  );
}

export default PropertyFeature;